import { zhCN_menu } from './menu'
import { zhCN_system } from './sys'
import { zhCN_crm_lead } from './crm/lead'
import { zhCN_wecom } from './wecom'

const zh_CN = {
	...zhCN_menu,
	...zhCN_system,
	...zhCN_crm_lead,
	...zhCN_wecom
}

export default zh_CN
